import { colors } from 'coreComponents/design-system/variables/colors/colors';
import styled from 'styled-components';
export const Wrapper = styled.div `
  color: #000000;
  font-size: 12px;
  min-height: 45px;
  letter-spacing: 0;
  padding-top: 10px;
  position: relative;
`;
export const StyledCheckbox = styled.input `
  border: 1px solid
    ${({ state }) => (state === 'error' ? '#f00' : colors.borderGray)};
  border-radius: 2px;
  height: 15px;
  margin-right: 8px;
  width: 15px;

  &:focus {
    border: 1px solid #355c7e;
  }

  &:focus + label {
    color: #355c7e;
  }
`;
export const StyledLabel = styled.label `
  background-color: #fff;
  opacity: 0;
  position: absolute;
  left: 5px;
  top: 0px;

  ${({ state }) => {
    if (state === 'error') {
        return 'color: #f00;';
    }
    return null;
}}
`;
export const StyledCheckboxLabel = styled.label `
  display: flex;
  align-items: baseline;

  ${({ state }) => {
    if (state === 'error') {
        return 'color: #f00;';
    }
    return null;
}}
`;
export const StyledError = styled.div `
  color: #f00;
  font-size: 12px;
  margin: 2px 0px 0px 5px;
`;
